import axios from 'axios'

export default class BokbasenService {
  static async getBokbasenRawData (sinceDays) {
    return axios
      .get(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/test/bokbasen/raworders', {
        params: {
          sinceDays: sinceDays
        }
      })
      .then(response => response)
  }
}
